'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ContentCardHeader = require('../ContentCardHeader');

var _ContentCardHeader2 = _interopRequireDefault(_ContentCardHeader);

var _ContentCardImage = require('../ContentCardImage');

var _ContentCardImage2 = _interopRequireDefault(_ContentCardImage);

var _ContentCardText = require('../ContentCardText');

var _ContentCardText2 = _interopRequireDefault(_ContentCardText);

var _withContentCardFooter = require('../../hocs/withContentCardFooter');

var _withContentCardFooter2 = _interopRequireDefault(_withContentCardFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InstagramPhotoContentCard = function InstagramPhotoContentCard(props) {
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_ContentCardHeader2.default, { isLarge: props.isLarge, iconType: 'instagram' }),
    _react2.default.createElement(_ContentCardImage2.default, {
      src: props.imageURL,
      modalEnabled: props.modalEnabled,
      isLarge: props.isLarge
    }),
    _react2.default.createElement(
      'a',
      { href: props.mediaPageUri, target: '_blank', rel: 'noopener noreferrer' },
      _react2.default.createElement(_ContentCardText2.default, { isLarge: props.isLarge, text: props.text })
    ),
    props.messengerShareButton
  );
};

InstagramPhotoContentCard.propTypes = {
  authorHandle: _propTypes2.default.string.isRequired, // eslint-disable-line react/no-unused-prop-types
  imageURL: _propTypes2.default.string.isRequired,
  mediaPageUri: _propTypes2.default.string,
  messengerShareButton: _propTypes2.default.node,
  text: _propTypes2.default.string.isRequired,
  modalEnabled: _propTypes2.default.bool,
  isLarge: _propTypes2.default.bool
};

InstagramPhotoContentCard.defaultProps = {
  mediaPageUri: null,
  messengerShareButton: null,
  caption: '',
  modalEnabled: false,
  isLarge: false
};

InstagramPhotoContentCard.displayName = 'InstagramPhotoContentCard';

exports.default = (0, _withContentCardFooter2.default)(InstagramPhotoContentCard);